(()=>{const root=document.querySelector('.moam-homepage');if(!root)return;
const slider=root.querySelector('[data-slider]');
if(slider){
  root.querySelectorAll('[data-direction]').forEach(button=>button.addEventListener('click',()=>{
    const card=slider.querySelector('.clean-card');
    slider.scrollBy({left:(card.offsetWidth+26)*Number(button.dataset.direction),behavior:'smooth'});
  }));
  slider.addEventListener('keydown',event=>{
    if(event.key==='ArrowRight'||event.key==='ArrowLeft'){
      event.preventDefault();
      const card=slider.querySelector('.clean-card');
      slider.scrollBy({left:(card.offsetWidth+26)*(event.key==='ArrowRight'?1:-1),behavior:'smooth'});
    }
  });
}
const autoSlider=root.querySelector('[data-auto-slider]');
if(autoSlider&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches){
  let paused=false;
  let last=performance.now();
  const pause=()=>paused=true;
  const resume=()=>{paused=false;last=performance.now()};
  autoSlider.addEventListener('mouseenter',pause);
  autoSlider.addEventListener('mouseleave',resume);
  autoSlider.addEventListener('focusin',pause);
  autoSlider.addEventListener('focusout',resume);
  autoSlider.addEventListener('pointerdown',pause);
  autoSlider.addEventListener('pointerup',resume);
  const toggle=root.querySelector('[data-auto-toggle]');
  toggle?.addEventListener('click',()=>{
    paused=!paused;
    toggle.setAttribute('aria-pressed',String(paused));
    toggle.textContent=paused?'Play slideshow':'Pause slideshow';
    if(!paused) last=performance.now();
  });
  const move=now=>{
    if(!paused){
      autoSlider.scrollLeft+=(now-last)*.045;
      if(autoSlider.scrollLeft>=autoSlider.scrollWidth/2) autoSlider.scrollLeft-=autoSlider.scrollWidth/2;
    }
    last=now;
    requestAnimationFrame(move);
  };
  requestAnimationFrame(move);
}
const stickyCta=root.querySelector('.sticky-cta');
const hero=root.querySelector('.hero');
const productClose=root.querySelector('.product-close');
if(stickyCta&&hero){
  let heroPassed=false;
  let closeVisible=false;
  const updateSticky=()=>stickyCta.classList.toggle('is-visible',heroPassed&&!closeVisible);
  const heroObserver=new IntersectionObserver(([entry])=>{
    heroPassed=!entry.isIntersecting&&entry.boundingClientRect.bottom<0;
    updateSticky();
  },{threshold:0});
  heroObserver.observe(hero);
  if(productClose){
    const closeObserver=new IntersectionObserver(([entry])=>{
      closeVisible=entry.isIntersecting;
      updateSticky();
    },{threshold:.08});
    closeObserver.observe(productClose);
  }
}

})();
